import { render, staticRenderFns } from "./TagsAutomation.vue?vue&type=template&id=b2b29d62&"
import script from "./TagsAutomation.vue?vue&type=script&lang=js&"
export * from "./TagsAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports